import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Play } from "lucide-react";

const LivesPage = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState({
    title: "",
    embedId: ""
  });

  const openVideoDialog = (title: string, embedId: string) => {
    setSelectedVideo({ title, embedId });
    setDialogOpen(true);
  };

  const videos = [
    {
      id: "jWG98KGDWwA",
      title: "Live #1 - Os Melhores Sites da Internet",
      description: "Conteúdo exclusivo sobre os melhores sites para você conhecer e utilizar.",
      type: "live"
    },
    {
      id: "FeaOY4v65yk",
      title: "Live #2 - Dicas e Truques para Sites",
      description: "Aprenda a usar os melhores sites da internet com essas dicas e truques.",
      type: "live"
    },
    {
      id: "TpCLyrRg6wk",
      title: "Como Usar os Melhores Sites",
      description: "Tutorial completo sobre como usar os melhores sites da internet.",
      type: "video"
    },
    {
      id: "frvHdwWn_FY",
      title: "Guia Completo para Iniciantes",
      description: "Se você está começando agora, este é o guia perfeito para você.",
      type: "video"
    },
    {
      id: "xFur7rNtaPE",
      title: "Segredos dos Melhores Sites",
      description: "Descubra segredos que poucos conhecem sobre os melhores sites da internet.",
      type: "video"
    },
    {
      id: "Jd8xNb8PND8",
      title: "Dica Rápida - Melhores Sites",
      description: "Uma dica rápida sobre como aproveitar ao máximo os melhores sites.",
      type: "short"
    }
  ];

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto px-4 pt-24 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent py-2">
            Lives e Vídeos Recomendados
          </h1>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto">
            Assista às nossas lives e vídeos com dicas, tutoriais e conteúdo exclusivo sobre os melhores sites da internet.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video) => (
            <Card key={video.id} className="overflow-hidden border border-border h-full flex flex-col">
              <CardHeader>
                <div className="flex items-center gap-2">
                  <span className={`px-2 py-1 text-xs rounded-full ${
                    video.type === 'live' 
                      ? 'bg-red-500/10 text-red-500' 
                      : video.type === 'short' 
                        ? 'bg-blue-500/10 text-blue-500' 
                        : 'bg-green-500/10 text-green-500'
                  }`}>
                    {video.type === 'live' ? 'Live' : video.type === 'short' ? 'Short' : 'Vídeo'}
                  </span>
                  <CardTitle>{video.title}</CardTitle>
                </div>
                <CardDescription>{video.description}</CardDescription>
              </CardHeader>
              <CardContent className="flex-grow">
                <div 
                  className="aspect-video bg-muted/30 rounded-md flex items-center justify-center mb-4 overflow-hidden relative group cursor-pointer"
                  onClick={() => openVideoDialog(video.title, video.id)}
                >
                  <img 
                    src={`https://img.youtube.com/vi/${video.id}/mqdefault.jpg`} 
                    alt={video.title}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <Play size={48} className="text-white" />
                  </div>
                </div>
                <Button 
                  onClick={() => openVideoDialog(video.title, video.id)}
                  className="w-full"
                >
                  <Play size={16} className="mr-2" />
                  Assistir Agora
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </main>

      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent className="max-w-4xl">
          <DialogHeader>
            <DialogTitle>{selectedVideo.title}</DialogTitle>
            <DialogDescription>
              Assista ao vídeo abaixo
            </DialogDescription>
          </DialogHeader>
          <div className="aspect-video w-full">
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${selectedVideo.embedId}`}
              title={selectedVideo.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </DialogContent>
      </Dialog>

      <Footer />
    </div>
  );
};

export default LivesPage;